import { gql } from "@apollo/client"

export const TOURNAMENT_MATCH_UPDATE = gql`
  mutation TournamentMatchUpdate($TournamentMatchUpdateInput: TournamentMatchUpdateInput!) {
    TournamentMatchUpdate(input: $TournamentMatchUpdateInput) {
      status {
        success
        name
        detail
      }
    }
  }
`
